<template>
  <div v-if="foundItems !== undefined">
    <form class="a-sort" action="">
      <p class="a-sort__see">
        Результат: {{foundItems}} пользователя
      </p>
      <div class="a-sort__block-sort">
        <div class="a-sort__left-block">
          <div class="a-sort__label">Сортировать:</div>
          <dropdown-new class="a-sort__select" v-model="order" @change="onOrderChange">
            <option :value="enums.SortOrder.EMPTY">По умолчанию</option>
            <option :value="enums.SortOrder.ASCENDING">По дате регистрации ↑</option>
            <option :value="enums.SortOrder.DESCENDING">По дате регистрации ↓</option>
          </dropdown-new>
        </div>
        <div class="a-sort__right-block">
          <button class="gui-btn gui-btn--red gui-btn--w-247" type="button">Добавить пользователя</button>
          <button class="gui-btn gui-btn--red gui-btn--w-140" type="button" @click="exportUsersList">Экспорт</button>
        </div>
      </div>
    </form>

    <div class="a-container-form">
      <div class="table-tab__container" tabindex="1" style="overflow: hidden; outline: none;">
        <table class="table-tab__block table " style="width: 1200px">
          <thead class="table-tab__thead">
          <tr class="table-tab__height-auto-column-header" style="height: 48px;">
            <th>ФИО</th>
            <th>Контрагент</th>
            <th>УНП/УНН</th>
            <th>Роль</th>
            <th>Статус</th>
            <td>Аккредитация</td>
          </tr>
          </thead>
          <tbody class="table-tab__tbody">
          <tr class="table-tab__height-auto-column-body table-tab__tr-border" v-for="person in items">
            <td>
              <router-link class="table-tab__color u-text-underline"
                           :to="{name: $route.meta.details, params: { userId: person.id, tab: 'account'}}">
                {{person | fullName}}
              </router-link>
            </td>
            <td>
              <router-link class="table-tab__color u-text-underline"
                           :to="{name: $route.meta.details, params: { userId: person.id, tab: 'contractor'}}">
                {{person.fullName | defaultValue('Не заполнено')}}
              </router-link>
            </td>
            <td>{{person.uid}}</td>
            <td>{{$t(person.role.label)}}</td>
            <td>
              {{$t(person.userAccreditationState.label)}}
            </td>
            <td>
              <router-link v-if="person.accreditationState.PROCESSING"
                           class="table-tab__color u-text-underline"
                           :to="{name: $route.meta.details, params: { userId: person.id, tab: 'accreditation'}}">
                {{$t(person.accreditationState.label)}}
              </router-link>
              <template v-else>
              {{$t(person.accreditationState.label)}}
              </template>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <button class="gui-btn gui-btn--more u-margin-24-auto"
            type="button"
            @click="fetchMoreUsers"
            v-if="foundItems !== items.length">
      {{$t('buttons.show-more')}}
    </button>
  </div>
</template>

<script>
  export default {

    data: () => ({
      order: undefined,
    }),

    computed: {
      foundItems() { return this.$store.state.search.users.total },
      items() { return this.$store.state.search.users.items }
    },

    methods: {
      exportUsersList() {
        this.$store.dispatch('exportUsersList');
      },

      fetchMoreUsers() {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('fetchMoreUsers');
          }
          catch(e) {
            console.error('unable to fetch more users', e);
          }
        });
      },

      onOrderChange() {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('fetchSortedUsers', { order: this.order });
          }
          catch(e) {
            console.error('unable to fetch sorted users list', e);
          }
        });
      }
    }
  }
</script>

<style scoped>

</style>
